import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CommonService } from 'src/app/shared/utils/common.service';
import { Utility } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-shared-user-access-detail-default',
  templateUrl: './shared-user-access-detail-default.component.html',
  styleUrls: ['./shared-user-access-detail-default.component.scss'],
})
export class SharedUserAccessDetailDefaultComponent
  implements OnInit
{
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  routeType!: any;
  constructor(
    private activatedroute: ActivatedRoute,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.activatedroute.data.subscribe((data: any) => {
      this.routeType = data?.type;
    });
    this.activatedroute.paramMap.subscribe((paramMap) => {
      if (paramMap.get('userGroupId')) {
        const userGroupId = Utility.decodeFromBase64(
          paramMap.get('userGroupId') || ''
        );
        this.commonService.setUserGroupId(userGroupId);
      }
    });
  }

}
